import { createContext } from 'react';
import {
  GetCostBreakdownResponseModel,
  GetQuotationRequestResponseModel,
} from '../services/quote.interfaces';

interface QuoteContextProps {
  quoteDetails: GetQuotationRequestResponseModel | null;
  quoteCostBreakdown: GetCostBreakdownResponseModel | null;
  quoteReference: string | null;
  trackingRef: string | null;
}

export const QuoteContext = createContext<QuoteContextProps>({
  quoteDetails: null,
  quoteCostBreakdown: null,
  quoteReference: null,
  trackingRef: null,
});
